import React, { useContext, useState, useEffect } from 'react'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import useStyles from './Style'
import { FileContext } from '../../Context'
import ArrowStep1 from '../Arrow/Step1'
import ArrowStep2 from '../Arrow/Step2'

const DropZone: React.FC = () => {
  const { Uppy } = useContext(FileContext)
  const classes = useStyles()
  const dashboardUppy = Uppy?.element('modal-upload') || undefined
  const [showArrow, setShowArrow] = useState(false)

  useEffect(() => {
    if (Uppy?.formatedFiles && Object.keys(Uppy?.formatedFiles).length > 0) {
      setTimeout(() => {
        setShowArrow(true)
      }, 10)
    }
  }, [Uppy?.formatedFiles])
  return (
    <>
      <div className={classes.container}>
        <img
          className={classes.illustration}
          src={FlatsyTheme.image.collecting}
          alt="illustration"
        />
        <div>
          <ArrowStep1 />
          {dashboardUppy}
          <ArrowStep2 show={showArrow} />
        </div>
      </div>
    </>
  )
}

export default DropZone
